import React from 'react';
import { SvgIcon } from '@mui/material';

function KosherIcon({ color = '#757575', ...props }) {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ width: 20, height: 20 }} {...props}>
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.15" x="2.48413" y="1.97949" width="20" height="20" rx="4" fill={color} />
        <path d="M8.6582 16.9486V7.05151H10.5277V11.6152L14.294 7.05151H16.5759L12.4383 11.9313L16.837 16.9486H14.4727L10.5277 12.4399V16.9486H8.6582Z" fill={color} />
      </svg>

    </SvgIcon>
  );
}
export default KosherIcon;
